import React from 'react';
import UnifiedModal from '../UnifiedModal';
import './ContentModal.css';

/**
 * Content Modal - For displaying content like diagrams, images, etc.
 * Perfect for the AI Diagram Modal use case
 */
const ContentModal = ({ 
  isOpen, 
  onClose, 
  title,
  children,
  size = 'full',
  showHeader = true,
  headerActions = null,
  footer = null,
  className = '',
  ...props
}) => {
  return (
    <UnifiedModal 
      isOpen={isOpen} 
      onClose={onClose} 
      size={size}
      className={`content-modal ${className}`}
      showCloseButton={!showHeader} // Hide default close if we have header
      ariaLabel={title || 'Content modal'}
      {...props}
    >
      {showHeader && (
        <div className="content-modal-header">
          <h2 className="content-modal-title">{title}</h2>
          <div className="content-modal-header-actions">
            {headerActions}
            <button
              className="content-modal-close-header"
              onClick={onClose}
              aria-label="Close modal"
              data-testid="content-modal-close"
            >
              ×
            </button>
          </div>
        </div>
      )}
      
      <div className="content-modal-body">
        {children}
      </div>
      
      {footer && (
        <div className="content-modal-footer">
          {footer}
        </div>
      )}
    </UnifiedModal>
  );
};

export default ContentModal;